export default "__VITE_ASSET__CIs7Kcxq__"